var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Bluebird from "bluebird";
import ObjectLoader from "../services/mutableObjectLoader";
import socketService from "../services/socket.service";
import sessionService from "../services/session.service";
import ChatLoader from "./chat";
var ChatList = /** @class */ (function () {
    function ChatList(chatIDs) {
        this.chatIDs = chatIDs;
    }
    ChatList.prototype.get = function () {
        return this.chatIDs;
    };
    ChatList.prototype.set = function (chatIDs) {
        this.chatIDs = chatIDs;
    };
    return ChatList;
}());
export { ChatList };
var ChatListLoader = /** @class */ (function (_super) {
    __extends(ChatListLoader, _super);
    function ChatListLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ChatListLoader;
}(ObjectLoader({
    download: function () { return socketService.definitlyEmit("chat.getAllIDs", {}).then(function (response) { return response.chatIDs; }); },
    load: function (chatResponse) { return Bluebird.resolve(chatResponse); },
    getID: function () { return sessionService.getUserID(); },
    restore: function (chatIDs, previousInstance) {
        var firstLoadedIndex = chatIDs.findIndex(function (id) { return ChatLoader.isLoaded(id); });
        var chatsToLoad = firstLoadedIndex === -1 ? [] : chatIDs.slice(0, firstLoadedIndex);
        return Bluebird.all(chatsToLoad.map(function (id) { return ChatLoader.get(id); })).then(function () {
            if (previousInstance) {
                previousInstance.set(chatIDs);
                return previousInstance;
            }
            return new ChatList(chatIDs);
        });
    },
    shouldUpdate: function () { return Bluebird.resolve(true); },
    cacheName: "chatList"
})));
export default ChatListLoader;



//////////////////
// WEBPACK FOOTER
// ./js/messages/chatList.ts
// module id = null
// module chunks = 